import React from "react";
import { i18n } from '../../../lang/i18n';
import DC from "../../../common/DataConnector";
import BackArrow from "../../../components/BackArrowComponent/BackArrow";
import CustomerAddress from "./CustomerAddress";
import ModalConfirm from "../../../components/ModalComponent/ModalConfirm";
import ScrollToTop from "../../../components/ScrollToTop";

export default function CustomerAddresses()
{
    const [addresses, setAddresses] = React.useState<any[]>([])
    const [address, setAddress] = React.useState<any>(undefined)
    const [addressToDelete, setAddressToDelete] = React.useState<any>(undefined)

    const modalDelete = {
        show: true,
        text: '¿Confirmas la eliminación de esta dirección?',
        btn1Name: 'Aceptar',
        btn1OnClick: function ()
        {
            addressDelete()
            setAddressToDelete(undefined)
        },
        btn2Name: 'Cancelar',
        btn2OnClick: function ()
        {
            setAddressToDelete(undefined)
        }
    };

    React.useEffect(() =>
    {
        (async function ()
        {
            await loadData()
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function loadData()
    {
        let content = await DC.Get('/customer/addresses', {});
        if (content.wasOk) {
            setAddresses(content.data);
        }
    }
    async function addressDelete()
    {
        let content = await DC.Delete('/customer/addresses/' + addressToDelete.addressId);
        if (content.wasOk) {
            await loadData()
            setAddressToDelete(undefined)
        }
    }

    function onAddClick()
    {
        setAddress({
            addressId: 0, contactFullname: '', contactPhone: ''
            , addressLine1: '', addressLine2: '', cp: '', city: { code: '', name: '' }
            , province: { code: '', name: '' }, notes: '', isDefault: true
        })
    }
    function onClose()
    {
        setAddress(undefined)
        loadData();
    }
    function onAddressDelete(item: any)
    {
        setAddressToDelete(item)

    }

    return (<div className="users">
        <ScrollToTop />
        {!address && <>
            <div className="main-subtitle">
                <h3>{i18n.CustomerAddress.Title}</h3>
            </div>
            <div className="addresses">
                {addresses.map((item: any, index: number) => (
                    <div key={index} className="address">
                        {item.isDefault && <span className="address-default">Dirección por defecto</span>}
                        <div><b>{item.contactFullName}</b></div>
                        <div>{item.addressLine1}</div>
                        <div>{item.addressLine2}</div>
                        <div>{item.city.name}</div>
                        <div>{item.cp} - {item.province.name}</div>
                        <div>Teléfono de contacto: {item.contactPhone}</div>
                        <div>
                            <button className="btn" onClick={() => setAddress(item)}>Editar</button>
                            {index > 0 && <button className="btn ml-3" onClick={() => onAddressDelete(item)}>Eliminar</button>}
                        </div>
                    </div>
                ))}
            </div>
            <div className="text-center">
                <button className="btn" onClick={onAddClick}>{i18n.CustomerAddress.AddAddress}</button>
            </div>
            <BackArrow path="/user" />
        </>}
        {address && <CustomerAddress address={address} onClose={onClose} showBack={true} />}
        {addressToDelete && <ModalConfirm conf={modalDelete} />}
    </div>
    );
}